"use strict";

define('components/strings',[], function() {
    var HTML_SPECIAL_CHARACTERS = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': '&quot;',
        "'": '&#39;',
        "/": '&#x2F;'
    };

    var stringsComponent = {
        escapeHtml: function(string) {
            return String(string).replace(/[&<>"'/]/g, function (s) {
                return HTML_SPECIAL_CHARACTERS[s];
            });
        }
    };

    return stringsComponent;
});

